import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

/**
 * Get a UUID for the most recently moved predicate
 * @returns object | null
 */
export const useCriteriaStoreLastMovedUuid = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const lastMovedUuid = useStore(store, (s) => s.lastMovedUuid);

    return lastMovedUuid;
};
